import type { FaireProductEntity } from "../../entity_types/product";

export const p_5fgfosxe9q: FaireProductEntity = {
  token: "p_5fgfosxe9q",
  type: "product",
  name: "Minnesota Rocks 550-Piece Puzzle",
  brandName: "Puzzles That Rock",
  imageUrl:
    "https://cdn.faire.com/fastly/3651043cfabc1f1142628e0ee8f6826aa60720afa0dc7671cf120dff29518d32.jpeg",
  priceDollars: 11,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/05593792c198a113fb30bda0fca44648e592bd2ac08f892582755b5809691e23.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
